import { OcdDetailsQuestionsManager } from "../components/OcdDetailsQuestionsManager";
import { OcdThemesManager } from "../components/OcdThemesManager";
import { SettingCard } from "../components/SettingCard";

export const OcdProfileSettingsTab = () => (
  <>
    <SettingCard>
      <OcdThemesManager />
    </SettingCard>
    <SettingCard>
      <OcdDetailsQuestionsManager />
    </SettingCard>
  </>
);
